import { createSlice } from "@reduxjs/toolkit";
import {
  EnumListShowRowCountList,
  EnumSortTypes,
} from "../../../common/enums/common.enums";
import {
  AssessmentTypeDTO,
  InspectionAssignmentOverviewDTO,
  PaginationDTO,
  SiteDTO,
  StatusStatisticsDTO,
  StatusSummaryCountDTO,
} from "../../../common/types/common.dto.types";

// project imports
import { InspectionAssignmentOverviewPageType } from "./InspectionAssignmentOverviewPage.types";

// ==============================|| VIEWS - PAGES - ASSESSMENT TYPE WIZARDS - REDUCER ||============================== //

const initialState = {
  Data: {
    Data: [] as Array<InspectionAssignmentOverviewDTO>,
    PageSize: EnumListShowRowCountList.ListShowRowCountPerPage_3,
    SelectedPage: 1,
    StatusSummaryCount: {} as StatusSummaryCountDTO,
  } as PaginationDTO,
  InspectionAssignmentOverviewSearchParameter: {
    InspectionStatusId: 0,
    BasicSearchValue: "",
    AssessmentTypeGroupId: "0",
    SelectedPage: 1,
    ListPageSize: EnumListShowRowCountList.ListShowRowCountPerPage_3,
    ShowCompletedInspection: false,
    SelectedSiteIds: [] as Array<number>,
    PlannedCompletionDateSortState: EnumSortTypes.Default,
  } as InspectionAssignmentOverviewDTO,

  InspectionAssignmentOverviewStatusSummary: [] as Array<StatusStatisticsDTO>,
  InspectionAssessmentSummary: [] as Array<AssessmentTypeDTO>,
  InspectionAssignmentOverviewYears: [] as Array<number>,
  InspectionSiteList: [] as Array<SiteDTO>,
  DataLoading: false,
} as InspectionAssignmentOverviewPageType;

export const inspectionAssignmentOverviewSlice = createSlice({
  name: "InspectionAssignmentOverview",
  initialState: initialState,
  reducers: {
    setAssignedInspections: (
      state: InspectionAssignmentOverviewPageType,
      action: { payload: InspectionAssignmentOverviewPageType; type: string }
    ) => {
      return {
        ...state,
        Data: {
          ...state.Data,
          Data: action.payload.Data?.Data ?? [],
          SelectedPage: action.payload.Data?.SelectedPage,
          PageSize: action.payload.Data?.PageSize,
        } as PaginationDTO,
        InspectionAssignmentOverviewStatusSummary:
          action.payload?.InspectionAssignmentOverviewStatusSummary,
        InspectionAssessmentSummary:
          action.payload?.InspectionAssessmentSummary,
        InspectionAssignmentOverviewYears:
          action.payload?.InspectionAssignmentOverviewYears,

        InspectionSiteList: action.payload?.InspectionSiteList,
      };
    },
    setInspectionAssignmentOverviewSearchParameter: (
      state: InspectionAssignmentOverviewPageType,
      action: { payload: InspectionAssignmentOverviewDTO; type: string }
    ) => {
      return {
        ...state,
        InspectionAssignmentOverviewSearchParameter: action.payload,
      };
    },
    resetAssignedInspections: () => {
      return initialState;
    },
  },
});

export const inspectionAssignmentOverviewReducerActions =
  inspectionAssignmentOverviewSlice.actions;
export const inspectionAssignmentOverviewReducer =
  inspectionAssignmentOverviewSlice.reducer;
